import { styled } from '@clickcease/cc-client-components-lib'

export const GlobalNotificationStyled = styled('div', {
  all: 'unset',
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  color: '$white',
  backgroundColor: '$primaryColor',
  fontSize: '$lg',
  fontWeight: '$sb',
  padding: '$6',
  gap: '$3',

  ['svg']: {
    marginRight: '$3',
    height: '$md',
    width: '$md',
    stroke: '$white',
  },
})

export const AnyQuestionsSpan = styled('span')

export const ScheduleCallLink = styled('a', {
  color: '$white',
})

export const GlobalNotificationNoCCDaysLeftButton = styled('span', {
  textDecoration: 'underline',
  cursor: 'pointer',
})
